import React from "react";
import "./mspsettingsv2.scss"
import { Col } from "react-bootstrap";

const SettingsPageBlockItem = ({
  label = '',
  value = '',
  bottomBorder = true,
  show = true,
  children,
  itemStyle,
  labelStyle,
  description,
  onClick = () => { }
}) => {
  return (
    <>
      {show &&
        <Col xs={12} onClick={onClick}>
          <div className={`${children ? 'pointer' : ''} ${itemStyle ? itemStyle : 'name-detail'} w-100 d-flex align-items-center justify-content-between`}>
            <div>
              <div className={`${labelStyle ? labelStyle : 'name-label'}`}>{label}</div>
              {description && (<div className="greyText">{description}</div>)}
            </div>
            <div className="d-flex align-items-center">
              <span className={`name ${children ? '' : 'mr-2'}`}>{value}</span>
              {children && children}
            </div>
          </div>
          {bottomBorder && (<hr className="m-0" />)}
        </Col>
      }
    </>
  );
};

export default SettingsPageBlockItem;
